export default "__VITE_ASSET__rzWg5Oxc__"